import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SavedSearchCommonDataService {
  public unsavedChanges: boolean = false;
  public currentSearchId: number | undefined = undefined;

  public reset() {
    this.unsavedChanges = false;
    this.currentSearchId = undefined;
  }

  public clearSavedSearch() {
    this.unsavedChanges = true;
    this.currentSearchId = undefined;
  }
}
